// 마케팅 이벤트 미션 타입
export enum MissionType {
  MISSION_1 = 'MISSION_1',
  MISSION_2 = 'MISSION_2',
}
